<template>
  <modal
    name="modal--product-prices"
    transition="nice-modal-fade"
    :click-to-close="true"
    :width="350"
    :height="'auto'"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4 rounded-lg"
    >
      <h1
        class="text-xl sm:text-2xl md:text-3xl leading-tight text-center flex flex-row justify-center font-normal"
      >
        <span>{{ name }}</span>
      </h1>
      <div v-if="prices">
        <chart-products :id="id" />
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChartProducts from '@/components/ChartProducts.vue'
export default {
  name: 'ModalProductPrices',
  data() {
    return {
      id: null
    }
  },
  components: {
    ChartProducts
  },
  computed: {
    ...mapGetters('storeModule/invoices', ['productsCosts']),
    ...mapGetters('storeModule/products', ['productName']),
    name() {
      return this.id ? this.productName(this.id) : 'Cost History'
    },
    loading() {
      return this.$store.state.config.loading
    },
    prices() {
      return this.id && this.productsCosts[this.id]
        ? this.productsCosts[this.id]
        : null
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    hideModal() {
      this.$modal.hide('modal--product-prices')
    },
    beforeOpen: function(event) {
      this.id =
        event && event.params && event.params.id ? event.params.id : null
      this.setFabVisible(false)
      // console.log(this.productsCosts[this.id])
    },
    beforeClose: function() {
      this.setFabVisible(true)
    }
  }
}
</script>
